export default "__VITE_ASSET__e7b129ea__"